/** The flag emoji of a country by its ISO 3166-1 alpha-2 code: `es` → 🇪🇸. */
export function getFlagEmoji(iso2: string): string {
    return iso2.toUpperCase().replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397));
}
